import { styled } from "styled-components";

import { colorCSS } from "../../../styles";
import { redundantCssFromKebab } from "../../../styles/redundant-css";

export const Bar = styled.div`
    ${redundantCssFromKebab("left", "0")}
    ${redundantCssFromKebab("position", "absolute")}
    ${redundantCssFromKebab("right", "0")}
    ${redundantCssFromKebab("top", "0")}
`;

export const Progress = styled.div<{ complete: boolean }>`
    background: ${({ complete }) =>
        complete
            ? colorCSS("G300")
            : `linear-gradient(
    90deg,
    ${colorCSS("T75")} 0%,
    ${colorCSS("T300")} 99%
  )`};
    height: 0.25rem;
    transition: width 0.2s ease;
`;
